export const PO_CONVERSION_CONFIG = {
  sourceObject: 'PODOCUMENTENTRY',
  queryFields: [
    'WHENCREATED', 'DOCHDRID', 'VENDORID', 'PROJECTID', 'ITEMID', 'ITEMDESC', 
    'QUANTITY', 'UNIT', 'PRICE', 'RECORDNO', 'LOCATIONID', 'DEPARTMENTID', 
    'MEMO', 'FORM1099', 'FORM1099TYPE', 'FORM1099BOX', 'TASKID', 'COSTTYPEID', 
    'CUSTOMERID', 'CLASSID', 'BILLABLE', 'RETAINAGEPERCENTAGE', 'TRX_AMOUNTRETAINED', 
    'CONVERSIONTYPE', 'LINE_NO'
  ],
  outputColumns: [
    { name: 'transactiontype', source: null, type: 'blank' },
    { name: 'datecreated', source: 'WHENCREATED', type: 'field' },
    { name: 'createdfrom', source: 'DOCHDRID', type: 'field' },
    { name: 'vendorid', source: 'VENDORID', type: 'field' },
    { name: 'documentno', source: null, type: 'blank' },
    { name: 'referenceno', source: null, type: 'blank' },
    { name: 'vendordocno', source: null, type: 'blank' },
    { name: 'datedue', source: 'WHENCREATED', type: 'calculated', calc: 'addDays', days: 30 },
    { name: 'projectid', source: 'PROJECTID', type: 'field' },
    { name: 'itemid', source: 'ITEMID', type: 'field' },
    { name: 'itemdesc', source: 'ITEMDESC', type: 'field' },
    { name: 'quantity', source: 'QUANTITY', type: 'field' },
    { name: 'unit', source: 'UNIT', type: 'field' },
    { name: 'price', source: 'PRICE', type: 'field' },
    { name: 'sourcelinekey', source: 'RECORDNO', type: 'field' },
    { name: 'locationid', source: 'LOCATIONID', type: 'field' },
    { name: 'departmentid', source: 'DEPARTMENTID', type: 'field' },
    { name: 'memo', source: 'MEMO', type: 'field' },
    { name: 'form1099', source: 'FORM1099', type: 'field' },
    { name: 'form1099type', source: 'FORM1099TYPE', type: 'field' },
    { name: 'form1099box', source: 'FORM1099BOX', type: 'field' },
    { name: 'projectid2', source: 'PROJECTID', type: 'field' },
    { name: 'taskid', source: 'TASKID', type: 'field' },
    { name: 'costtypeid', source: 'COSTTYPEID', type: 'field' },
    { name: 'customerid', source: 'CUSTOMERID', type: 'field' },
    { name: 'vendorid2', source: 'VENDORID', type: 'field' },
    { name: 'classid', source: 'CLASSID', type: 'field' },
    { name: 'billable', source: 'BILLABLE', type: 'field' },
    { name: 'retainagepercentage', source: 'RETAINAGEPERCENTAGE', type: 'field' },
    { name: 'trx_amountretained', source: 'TRX_AMOUNTRETAINED', type: 'field' },
    { name: 'conversiontype', source: 'CONVERSIONTYPE', type: 'field' },
    { name: 'line_no', source: 'LINE_NO', type: 'field' },
  ]
};